
import React, { useState } from 'react';
import { Card } from '@/components/ui/card';
import ExitDateChart from '@/components/charts/ExitDateChart';
import RiskAssessmentDialog from './RiskAssessmentDialog';
import { Review } from '@/lib/types';

interface RecentEmployeeExitsProps {
  reviews: Review[];
}

const RecentEmployeeExits: React.FC<RecentEmployeeExitsProps> = ({ reviews }) => {
  const [showFullChart, setShowFullChart] = useState(false);

  const handleExpandChart = () => {
    setShowFullChart(true);
  };

  return (
    <>
      <Card className="bg-white border border-redflags-light/20">
        <ExitDateChart 
          reviews={reviews} 
          compact={true} 
          onExpandChart={handleExpandChart}
        />
      </Card>

      <RiskAssessmentDialog
        showFullChart={showFullChart}
        setShowFullChart={setShowFullChart}
        reviews={reviews}
      />
    </>
  );
};

export default RecentEmployeeExits;
